import axios from "axios";
// import { Navigate } from "react-router-dom";
// const navigate = useNavigate()
const baseUrl =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3500/"
    : process.env.REACT_APP_API_HOST
    // : "https://shimla-gem-api.herokuapp.com/";
const axiosInstance = axios.create({
  baseURL: baseUrl,
});



axiosInstance.interceptors.request.use(
  (request) => {
    console.log("requesting interceptors", request);
    return request;
  },
  (error) => {
    console.log("requesting interceptors error ", error.response);
    // alert("Token expired, Please re login");
    // Navigate({ to: "/login", replace: true });
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  (response) => {
    console.log("responding interceptors", response);
    return response;
  },
  (error) => {
    console.log("responding interceptors error ",error.toJSON());
   
      if(error.toJSON().message === 'Network Error'){
        alert('Server is offline');

      }
      if(error.toJSON().status === 500){
          alert('Server crashed');
          window.location.href = "/login";

          // dispatch({type: RELOAD});
      }
      if(error.toJSON().status === 401){
        console.log("session is expired ", error.toJSON())  
        alert('Session is expired, Log again');
          
          // Navigate({ to: "/login" });
          // return <Navigate to="/login" />;
          window.location.href = "/login";
      }

      

      console.log("server error", error.toJSON())
      return Promise.reject(error);
 
    // 
  }
);

// export default axios.create({
//   baseURL: baseUrl
// });

export default axiosInstance;
